var map = {
	"./admin-panel/admin-panel.module": [
		"./src/app/admin-panel/admin-panel.module.ts",
		"admin-panel-admin-panel-module"
	],
	"./cart-detail/cart-detail.module": [
		"./src/app/cart-detail/cart-detail.module.ts",
		"default~cart-detail-cart-detail-module~product-list-product-list-module",
		"cart-detail-cart-detail-module"
	],
	"./homepage/homepage.module": [
		"./src/app/homepage/homepage.module.ts",
		"homepage-homepage-module"
	],
	"./product-list/product-list.module": [
		"./src/app/product-list/product-list.module.ts",
		"default~cart-detail-cart-detail-module~product-list-product-list-module",
		"product-list-product-list-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;